import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageReviewPlanogramStore = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.ReviewStorePlanogramPage />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageReviewPlanogramStore = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageReviewPlanogramStore />
    </Suspense>
  );
};
